'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useSelectionSetContext, SelectionSetInputContext } from './selection-set.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SelectionSetInput = renderWithRef('SelectionSetInput', null, (n, a)=>{
    let { value: l, children: u, id: b, onChange: f } = n, _ = _object_without_properties(n, [
        "value",
        "children",
        "id",
        "onChange"
    ]), j = useSelectionSetContext(), O = useId(b), d = 'multi-select' === j.variant, y = d ? j.selectedValues[l] : j.selectedValue === l, m = d ? (e)=>{
        j.onSelectedValuesChange(_object_spread_props(_object_spread({}, j.selectedValues), {
            [l]: e.target.checked
        }), e);
    } : (e)=>{
        e.target.checked && j.onSelectedValueChange(l, e);
    }, g = _object_spread_props(_object_spread({
        type: d ? 'checkbox' : 'radio'
    }, _), {
        id: O,
        name: j.name,
        value: l,
        checked: y,
        onChange: composeEventHandlersUtil(f, m)
    });
    return jsxs(Fragment, {
        children: [
            jsx(RenderComp, {
                root: "input",
                forwardedRef: a,
                classNames: [
                    'swan-selection-set-input',
                    d ? 'swan-checkbox' : 'swan-radio'
                ],
                props: g
            }),
            jsx(SelectionSetInputContext.Provider, {
                value: {
                    selectionSetInputId: O
                },
                children: u
            })
        ]
    });
});

export { SelectionSetInput };
